import { Link } from "react-router-dom";

export const LEGAL_LINKS = [
  ["/privacy", "Privacy Policy"],
  ["/terms", "Terms & Conditions"],
  ["/cookies", "Cookie Policy"],
  ["/refund", "Refund Policy"],
  ["/disclaimer", "Disclaimer"],
];

export default function Footer({ compact = false }) {
  return (
    <footer className={`border-t border-border ${compact ? "py-4" : "py-6"} px-4 sm:px-8`} data-testid="app-footer">
      <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-muted-foreground">
        <span className="uppercase tracking-[0.18em] font-bold">Trifit.XPS</span>
        {LEGAL_LINKS.map(([to, label]) => (
          <Link key={to} to={to} target="_blank" rel="noreferrer"
            data-testid={`footer-link-${to.slice(1)}`}
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline">
            {label}
          </Link>
        ))}
        <span className="sm:ml-auto">© {new Date().getFullYear()} Svar TriFit Wellness Pvt. Ltd.</span>
      </div>
      <p className="text-[11px] text-muted-foreground mt-2 max-w-3xl" data-testid="footer-privacy-note">
        Athlete data is shared only with consent, can be exported or erased on request, and medical
        records stay with the athlete and their doctor.
      </p>
    </footer>
  );
}
